import * as React from "react";
import { Tooltip } from "../Tooltip";
import { TooltipProps as AntTooltipProps } from "antd";
import { ExternalLink } from "../../newcomponents/table/components/ExternalLink";
import { BugOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { DOCS_URL } from "../../envVariables";

interface Props {
  style?: any;
  className?: string;
  debug?: boolean;
}

export const InfoTooltip: React.FC<Props & AntTooltipProps> = ({ title: titleRaw, debug, ...props }) => {
  const Icon = debug ? BugOutlined : QuestionCircleOutlined;

  const title: React.ReactNode = React.useMemo(() => {
    if (!Array.isArray(titleRaw)) {
      return titleRaw as any;
    }

    const contents: React.ReactNode[] = [];

    for (const contentIndexStr in titleRaw) {
      const contentIndex = Number(contentIndexStr);
      const content = titleRaw[contentIndex];
      // TODO fix this, we used to display, now we dont
      if (content === "Custom_Memory_1") {
        contents.push(
          <div key={contentIndex}>
            For all available memory units, refer to{" "}
            <ExternalLink url={`${DOCS_URL}/reference/workload#resources`} label="this page" disableCopy />.
          </div>,
        );
      } else {
        contents.push(content);
      }
    }

    return contents;
  }, [titleRaw]);

  return (
    <Tooltip title={title} {...props}>
      <Icon className={props.className} style={{ marginLeft: 10, fontSize: 16, ...props.style }} />
    </Tooltip>
  );
};
